import React from 'react';

class TotalsTableWeeklyRow extends React.Component {

  render() {
  	const {OrderSum, PartnerId, PaymentFees, TicketQty, WeekEnd, WeekNumber, WeekStart, PointName, Username} = this.props.data;
    const {activecols} = this.props;

    return (
      <tr>
        <td>{WeekStart}</td>
        <td>{WeekEnd}</td>
        <td>{TicketQty}</td>
        <td>{OrderSum}</td>
        <td>{PaymentFees}</td>
        {activecols.pointName && <td>{PointName}</td>}
        {activecols.username && <td>{Username}</td>}
      </tr>
    );
  }
}

export default TotalsTableWeeklyRow;
